import { useState, useEffect } from 'react';
import { useGetTemplatesQuery } from '../store/services/cloudlab/cloudlab';
import { unlockedSoftwares, DevelopmentSoftwares } from '../helpers/Softwarelisting';

export const useTemplateManagement = () => {
  const [templateList, setTemplateList] = useState([]);
  const [isTemplatesLoading, setIsTemplatesLoading] = useState(true);
  const [showAll, setShowAll] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [templateInputConfigs, setTemplateInputConfigs] = useState([]);
  const [openGitModal, setOpenGitModal] = useState(false);
  const [createdEnvs, setCreatedEnvs] = useState([]);

  const { data: templatesData } = useGetTemplatesQuery();

  useEffect(() => {
    if (templatesData?.data?.templates) {
      const templates = templatesData.data.templates;
      // Sort templates: free ones first, then premium ones
      const sortedTemplates = [...templates].sort((a, b) => {
        const aIsFree = a.templateName.startsWith('vscode');
        const bIsFree = b.templateName.startsWith('vscode');

        // If one is free and other isn't, free comes first
        if (aIsFree !== bIsFree) {
          return aIsFree ? -1 : 1;
        }

        // If both are free or both are premium, sort alphabetically
        return a.templateName.localeCompare(b.templateName);
      });

      setTemplateList(sortedTemplates);
      setIsTemplatesLoading(false);

      // Get created environments from API response
      const createdSoftware = sortedTemplates
        .filter((item) => item?.userEnv?.envName) // Check if userEnv exists
        .map((item) => item.templateName);

      setCreatedEnvs(createdSoftware);
    }
  }, [templatesData]);

  const sortedTemplateList = [...templateList]
    .map(item => ({
      ...item,
      isFree: unlockedSoftwares.includes(item.templateName),
      isDevelopment: DevelopmentSoftwares.includes(item.templateName)
    }))
    .sort((a, b) => {
      // Free first, then paid, then alphabetical
      if (a.isFree !== b.isFree) return a.isFree ? -1 : 1;
      return a.templateName.localeCompare(b.templateName);
    });

  const handleInstall = (item, createEnvWithInputs) => {
    if (!item?._id) {
      console.error('Template missing _id:', item);
      return;
    }

    if (['vscode-python', 'vscode-nodejs'].includes(item.templateName)) {
      setSelectedTemplate(item);
      setTemplateInputConfigs(
        item.inputConfigKeys || ['codeServer.repository', 'codeServer.branch']
      );
      setOpenGitModal(true);
    } else if (item?.inputConfigKeys?.length > 0) {
      setSelectedTemplate(item);
      setTemplateInputConfigs(item.inputConfigKeys);
      setOpenGitModal(true);
    } else {
      // No modal needed, create directly
      createEnvWithInputs(item, undefined);
    }
  };

  const handleCloseGitModal = () => {
    setOpenGitModal(false);
  };

  return {
    templateList,
    isTemplatesLoading,
    showAll,
    setShowAll,
    selectedTemplate,
    templateInputConfigs,
    openGitModal,
    sortedTemplateList,
    handleInstall,
    handleCloseGitModal,
    createdEnvs,
    setCreatedEnvs
  };
}; 